<script setup lang="ts">
import { lazyStrings } from '@/strings';
import logoUrl from '@/assets/logo.svg';

interface Props {
  size?: number,
  className?: string,
}
withDefaults(defineProps<Props>(), {
  size: 32,
  className: '',
});


defineExpose({
  ...((__BUILD_MODE_IS_TEST__ && {
    TEST_ONLY: {
      // Export internal state and logic used only for testing here. Do not reference these in production logic.
    },
  }) || {}),
});

import "virtual:naidan-tailwind-css-module/1f4d4f59dfa1ef9783d8331478822891105136e87a0942eb29100bc5b18c248e.js";
import "virtual:naidan-tailwind-css-module/7978ab77a9d6c664cd1110ed3e5e865a265375805da871d2d81f5bd6bd6fe1f5.js";
</script>

<template>
  <div tw-class="relative flex items-center justify-center group" :style="{ width: size + 'px', height: size + 'px' }">
    <!-- Vibrant Glow Effect -->
    <div
      tw-class="absolute inset-0 bg-sky-400/30 dark:bg-blue-400/20 blur-2xl rounded-full scale-150 opacity-0 group-hover:opacity-100 transition-all duration-700"
    ></div>

    <!-- Standard img tag for perfect SVG rendering -->
    <!-- Vite will inline the logoUrl as a Base64 string for file:// compatibility -->
    <img
      :src="logoUrl"
      :width="size"
      :height="size"
      :style="{ width: size + 'px', height: size + 'px' }"
      tw-class="relative z-10 transition-all duration-500 hover:scale-110 hover:brightness-110"
      :class="className"
      :alt="lazyStrings.Logo__naidan_logo()"
    />
  </div>
</template>
